const AVAILABILITY_ERRORS = new Set(['slot_unavailable', 'slot_taken', 'booking_overlap', 'availability_changed'])
const PAYMENT_ERRORS = new Set(['payment_failed', 'checkout_failed', 'payment_declined', 'payment_unavailable'])
const VALIDATION_ERRORS = new Set([
  'invalid_skill_range', 'invalid_payment_plan', 'invalid_pricing', 'invalid_duration', 'duration_not_configured',
  'duration_required', 'duration_end_mismatch', 'racquet_capacity_exceeded',
  'non_members_not_allowed', 'guest_contact_required', 'invalid_primary_player',
  'invalid_player_selection', 'racquet_court_not_found',
])

export function getMemberRacquetBookingError(errorCode) {
  const code = String(errorCode || '').trim().toLowerCase()
  if (AVAILABILITY_ERRORS.has(code)) {
    return { category: 'availability', messageKey: "portalPresentation.member_that_court_has_just_been_taken_choose_another_available_time", message: 'That court has just been taken. Choose another available time.', canRefreshAvailability: true }
  }
  if (PAYMENT_ERRORS.has(code)) {
    return { category: 'payment', messageKey: "portalPresentation.member_payment_could_not_be_completed_your_court_has_not_been_booked", message: 'Payment could not be completed. Your court has not been booked.', canRefreshAvailability: false }
  }
  if (VALIDATION_ERRORS.has(code)) {
    return { category: 'validation', messageKey: "portalPresentation.member_we_couldn_t_complete_your_booking_your_court_has_not_been_booked_or_charged", message: "We couldn’t complete your booking. Your court has not been booked or charged.", canRefreshAvailability: false }
  }
  return { category: 'unknown', messageKey: "portalPresentation.member_we_couldn_t_complete_your_booking_please_try_again", message: 'We couldn’t complete your booking. Please try again.', canRefreshAvailability: false }
}
